export { ServicingPage } from './lib/servicing-page'
export { getStaticProps } from './lib/get-static-props'
export * from './lib/design-system/accordion'
export * from './lib/design-system/badge'
export { Image } from './lib/design-system/image'
export * from './lib/design-system/logo'
export * from './lib/design-system/table/cell'
export * from './lib/design-system/table'
export { Table as StoryblokTable } from './lib/storyblok/table/table'
export { Table as StoryblokTableAdapter } from './lib/storyblok/table/table'
export type {
  StoryblokTableCell,
  StoryblokTableRow,
  TableProps as StoryblokTableProps,
} from './lib/storyblok/table/table'
export * from './lib/storyblok/table-section'
export * from './lib/storyblok/accordion-section'
export type { StoryblokAccordionProps } from './lib/storyblok/accordion'

// Development-only, kept out of the component barrels so the component folders
// stay portable to the design system.
export { AccordionGallery } from './lib/design-system/accordion/gallery'
export { BadgeGallery } from './lib/design-system/badge/badge.gallery'
export { LogoGallery } from './lib/design-system/logo/logo.gallery'
